import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../../../ui/dialog";
import { Button } from "../../../../ui/button";
import { cancelJobIfNoShovellerApplied, cancelJob } from "../../../../../apiManager/houseOwner/matchShvoller";
import { setCredentials } from "../../../../../slices/authSlice";
import { IoMdClose } from "react-icons/io";


export function CancelDialog({ job, onSuccess, className, variant = "outline", size }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancelJob = async () => {
    // get user role from local storage
    const userData = JSON.parse(localStorage.getItem('userInfo'));
    console.log(userData)
    const userRole = userData.user.role;
    console.log("trigeered")
    try {
      setLoading(true);
      setError(null);

      let res;
      console.log(job)

      if (job.jobStatus === 'in-progress') {
        let shovellerId;
        if (userRole === 'houseOwner') {
          shovellerId = job.ShovelerInfo[0]?.ShovelerId._id;
          if (shovellerId === undefined) {
            shovellerId = job.ShovelerInfo[0]?.ShovelerId;
          }
        } else {
          shovellerId = job.ShovelerInfo[0]?.ShovelerId;
        }
        console.log(userRole)
        console.log(shovellerId)
        // For in-progress jobs, use cancelJob API with shovellerId

        // const shovellerId = job.ShovelerInfo[0]?.ShovelerId;
        // if (!shovellerId) {
        //   setError('Shoveller information not found');
        //   return;
        // }
        res = await cancelJob(job._id, shovellerId, userRole);
      } else {
        // For other job statuses, use the original API
        res = await cancelJobIfNoShovellerApplied(job._id);
      }

      if (res.err) {
        setError(res.err || 'An error occurred while canceling the job');
        return;
      }

      const userData = JSON.parse(localStorage.getItem('userInfo'));
      dispatch(setCredentials({
        user: {
          id: userData.user.id,
          role: userData.user.role,
        },
        token: userData.token,
      }));

      setOpen(false);

      if (onSuccess) {
        onSuccess(job._id);
      } else {
        window.location.reload();
      }

    } catch (err) {
      setError('Failed to cancel job');
      console.error("Error cancelling job:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        variant={variant}
        size={size}
        className={className}
      >
        Cancel Job
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent onClick={(e) => e.stopPropagation()}>
          <DialogHeader>
            <DialogTitle>Cancel Job</DialogTitle>
            <DialogDescription>
              {job.jobStatus === 'in-progress'
                ? (
                  <span>
                    Are you sure you want to cancel this job?{" "}
                    <span className="font-semibold text-red-600">
                      Cancelling an accepted job will incur a fee of $10.
                    </span>
                  </span>
                )
                : "Are you sure you want to cancel this job? This action cannot be undone."
              }
            </DialogDescription>
          </DialogHeader>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}

          <DialogFooter>
            <Button
              variant="outline"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false)
              }}
              disabled={loading}
            >
              Keep Job
            </Button>
            <Button
              onClick={handleCancelJob}
              className="bg-red-600 hover:bg-red-700 text-white"
              disabled={loading}
            >
              {loading ? "Cancelling..." : (job.jobStatus === 'in-progress' ? "Yes, Cancel Job ($10 fee)" : "Yes, Cancel Job")}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}